import React, { ErrorInfo } from "react";

type Props = { children: React.ReactNode; errorFallback: React.ReactNode };

export class ErrorBoundary extends React.Component<Props> {
  state = {
    hasError: false,
    error: null,
  };

  constructor(props: Props) {
    super(props);
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // TODO: we probably want to log this somewhere
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorFallback;
    }
    return this.props.children;
  }
}
